export default __webpack_public_path__ + "right-bg31a2172.png";